import * as React from 'react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'

import './FilterFooter.scss'

const cancel = 'Cancel'

interface IFilterFooter {
  clickOnCancel: () => void
  clickOnApply: () => void
  applyButtonText?: string
  isApplyButtonInactive?: boolean
}

class FilterFooter extends React.Component<IFilterFooter> {
  public render() {
    const {
      clickOnCancel,
      clickOnApply,
      applyButtonText = 'Apply',
      isApplyButtonInactive = false,
    } = this.props

    return (
      <div className="filter-footer">
        <Button variant="ghost" onClick={clickOnCancel}>
          {cancel}
        </Button>
        <Button
          variant="default"
          disabled={isApplyButtonInactive}
          onClick={clickOnApply}
        >
          {applyButtonText}
        </Button>
      </div>
    )
  }
}

export default FilterFooter
